'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { SplitWizardData } from './split-wizard-state';


export type SplitWizardSubmitError =
    | { kind: 'email_exists' }
    | { kind: 'generic'; message: string };


export type SplitWizardSubmitResult = {
    checkoutUrl: string | null;
};


export type SplitWizardSubmitContextValue = {
    submit: (data: SplitWizardData) => Promise<SplitWizardSubmitResult | null>;
    loading: boolean;
    error: SplitWizardSubmitError | null;
    setError: (error: SplitWizardSubmitError | null) => void;
};


const SplitWizardSubmitContext = createContext<SplitWizardSubmitContextValue | null>(null);


type SplitWizardSubmitProviderProps = {
    children: ReactNode;
    value: SplitWizardSubmitContextValue;
};


export const SplitWizardSubmitProvider = ({ children, value }: SplitWizardSubmitProviderProps) => (
    <SplitWizardSubmitContext.Provider value={ value }>
        { children }
    </SplitWizardSubmitContext.Provider>
);


export const useSplitWizardSubmit = () => {
    const ctx = useContext(SplitWizardSubmitContext);
    if (!ctx) throw new Error('useSplitWizardSubmit must be used inside <SplitWizardSubmitProvider>');
    return ctx;
};
